import { Config } from '../types';

// Версионированный ключ — если будут breaking changes в shape Config,
// можно ввести _v2 и проигнорировать _v1.
const STORAGE_KEY = 'base_dca_config_v1';

/**
 * Загрузить Config из localStorage. Возвращает null если ничего не сохранено
 * или данные corrupt. НЕ восстанавливает приватные ключи (их нет в LS).
 */
export function loadConfig(): Partial<Config> | null {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== 'object') return null;
    return parsed as Partial<Config>;
  } catch (err) {
    console.warn('[configStorage] loadConfig failed:', err);
    return null;
  }
}

/**
 * Сохранить Config в localStorage. Игнорирует поля которые могут содержать
 * приватные ключи (на текущий момент в Config их нет, но это будущая защита).
 */
export function saveConfig(config: Config): void {
  try {
    const safe: Config = {
      rpcUrl: config.rpcUrl,
      tokenAddress: config.tokenAddress,
      ethAddress: config.ethAddress,
      tokenSymbol: config.tokenSymbol,
      tokenDecimals: config.tokenDecimals,
      chainId: config.chainId,
      dexType: config.dexType,
      selectedPoolId: config.selectedPoolId,
      selectedPoolInfo: config.selectedPoolInfo,
    };
    localStorage.setItem(STORAGE_KEY, JSON.stringify(safe));
  } catch (err) {
    console.warn('[configStorage] saveConfig failed:', err);
  }
}

/**
 * Очистить сохранённый Config — например, при logout-flow.
 */
export function clearConfig(): void {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch (err) {
    console.warn('[configStorage] clearConfig failed:', err);
  }
}
